import React from 'react';
import './style.scss';

const LoadingIndicator = ({ active }) => active && (<div className="loading-indicator" />);

export default LoadingIndicator;
